// JS
// Notg the cleaner way to do it but : 
// The page is waiting for a user interaction to load images (probably for performance improvement)
// This behavior cause UX problems on collections page. 
// We solve it by triggering two click event on the body (one event is not working, but two is working fine.)

window.addEventListener('load', function() {

  if(document.location.href.includes('/collections/')){
    document.body.click();
    document.body.click();
  }
 
});
